var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.question.getNextButtonCss(),
      attrs: { title: _vm.question.panelNextText },
      on: { click: _vm.nextPanelClick },
    },
    [
      _c("sv-svg-icon", {
        attrs: {
          iconName: _vm.question.cssClasses.progressBtnIcon,
          size: "auto",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }